module.exports = __webpack_public_path__ + "static/media/chevron.7144c3d2.svg";